import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { E as g, S as f } from "./icons.types-0722eef5.js";
function C({ title: i, titleId: s, size: h, width: n, height: o, extended: c = !1, ...a }) {
  const r = c ? g : f, t = h ? r[h] : n || r[c ? "s" : "l"], e = h ? r[h] : o || r[c ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: t,
      height: e,
      "aria-labelledby": s,
      ...a,
      children: [
        i ? /* @__PURE__ */ l("title", { id: s, children: i }) : null,
        /* @__PURE__ */ l("g", { clipPath: "url(#Thread_svg__a)", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M36.631 72h-.024c-12.235-.072-21.641-3.614-27.964-10.526C3.026 55.318.123 46.757.024 36.029v-.05c.099-10.736 3.002-19.29 8.627-25.445C14.966 3.614 24.38.072 36.607 0h.049c9.381.058 17.229 2.174 23.322 6.293 5.732 3.873 9.767 9.389 11.989 16.401l-6.97 1.707C61.224 12.52 51.679 6.45 36.623 6.358c-9.939.064-17.459 2.808-22.346 8.15C9.709 19.512 7.347 26.741 7.257 36c.09 9.26 2.452 16.488 7.028 21.492 4.887 5.35 12.407 8.093 22.346 8.15 8.963-.057 14.892-1.893 19.82-6.134 5.626-4.838 5.528-10.778 3.724-14.393-1.058-2.131-2.985-3.902-5.585-5.249-.656 4.054-2.124 7.337-4.387 9.814-3.026 3.305-7.315 5.112-12.744 5.371-4.108.195-8.069-.655-11.136-2.405-3.633-2.066-5.756-5.22-5.986-8.892-.221-3.57 1.394-6.854 4.543-9.244 3.01-2.283 7.241-3.622 12.243-3.874 3.682-.18 7.135-.036 10.316.425-.426-2.225-1.279-3.996-2.558-5.27-1.755-1.757-4.47-2.65-8.061-2.672h-.099c-2.886 0-6.806.699-9.299 3.96l-6.003-3.535c3.346-4.363 8.775-6.768 15.302-6.768h.148c10.915.058 17.418 5.926 18.066 16.164.369.137.738.28 1.098.425 5.093 2.102 8.816 5.285 10.776 9.209 2.722 5.464 2.977 14.37-5.29 21.477C55.198 69.48 47.53 71.935 36.657 72h-.025Zm3.428-35.071c-.828 0-1.665.021-2.526.065-6.273.31-10.185 2.836-9.963 6.43.23 3.765 4.961 5.514 9.512 5.298 4.182-.194 9.628-1.627 10.546-11.13-2.313-.44-4.846-.663-7.569-.663Z"
          }
        ) }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Thread_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  C as Thread
};
